var map = {
	"./arrange.svg": "e8ad",
	"./check.svg": "7bae",
	"./clipcats/animals.svg": "bde4",
	"./clipcats/beauty.svg": "4425",
	"./clipcats/plant.svg": "0f5f",
	"./clipcats/vehicles.svg": "2e27",
	"./clipcats/weather.svg": "1c20",
	"./clipcats/wedding.svg": "3d0a",
	"./delete.svg": "0d45",
	"./lock.svg": "9619",
	"./question.svg": "9872",
	"./rotate.svg": "f109",
	"./searchGlass.svg": "1982",
	"./unlock.svg": "d901"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";